export const GET_COMPANY_CLIENTS_REQUEST = "GET_COMPANY_CLIENTS_REQUEST";
export const GET_COMPANY_CLIENTS_RESPONSE = "GET_COMPANY_CLIENTS_RESPONSE";
export const GET_COMPANY_CLIENT_REQUEST = "GET_COMPANY_CLIENT_REQUEST";
export const GET_COMPANY_CLIENT_RESPONSE = "GET_COMPANY_CLIENT_RESPONSE";
export const CLEAR_COMPANY_CLIENT = "CLEAR_COMPANY_CLIENT";
export const UPDATE_COMPANY_CLIENT_REQUEST = "UPDATE_COMPANY_CLIENT_REQUEST";
export const UPDATE_COMPANY_CLIENT_RESPONSE = "UPDATE_COMPANY_CLIENT_RESPONSE";
export const CREATE_COMPANY_CLIENT_REQUEST = "CREATE_COMPANY_CLIENT_REQUEST";
export const CREATE_COMPANY_CLIENT_SUCCESS = "CREATE_COMPANY_CLIENT_SUCCESS";
export const CREATE_COMPANY_CLIENT_FAILURE = "CREATE_COMPANY_CLIENT_FAILURE";
